import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Can from 'containers/Can/Can';
import SubHeader from 'components/general/SubHeader/SubHeader';
import Flash from 'components/general/Flash/Flash';
import AccountLayout from 'components/layouts/AccountLayout';
import OrganisationCustomerView from './containers/OrganisationCustomerView';
import OrganisationCustomerEditForm from './containers/OrganisationCustomerEditForm';
import OrganisationCustomerNewTrialForm from './containers/OrganisationCustomerNewTrialForm';
import DeleteBtn from './components/DeleteBtn';
import { selectors } from './../../../../../shared/ducks/customer.duck';

const OrganisationProfile = ({ title, loading }) => (
  <AccountLayout
    title={title}
    loading={loading}
    section={{
      title: 'Customers',
      to: { type: 'ORGANISATION_CUSTOMERS' },
    }}
  >
    <AccountLayout.Section>
      <SubHeader
        title="Customer info"
      />
      <OrganisationCustomerView />

    </AccountLayout.Section>
    <Can action="update" on="Customer" field="profile">
      <AccountLayout.Section>
        <SubHeader
          title="Edit Customer"
        />
        <OrganisationCustomerEditForm />
      </AccountLayout.Section>

      {/*<AccountLayout.Section>*/}
      {/*  <SubHeader*/}
      {/*    title="Edit subscription"*/}
      {/*  />*/}
      {/*  <OrganisationCustomerNewTrialForm />*/}
      {/*</AccountLayout.Section>*/}

      {/*<AccountLayout.Section>*/}
      {/*  <SubHeader*/}
      {/*    title="Trial subscription"*/}
      {/*  />*/}
      {/*  <p>Start a trial subscription for this customer (overrides any existing trial)</p>*/}
      {/*  <OrganisationCustomerNewTrialForm />*/}
      {/*</AccountLayout.Section>*/}

      <AccountLayout.Section>
        <SubHeader
          title="Delete Customer"
        />
        <div className="u-space-no-pull">
          <Flash
            type="warning"
            message="Deleting a customer cannot be undone."
          />
          <DeleteBtn />
        </div>
      </AccountLayout.Section>
    </Can>
  </AccountLayout>
);

const getTitle = createSelector(
  selectors.data,
  R.prop('name'),
);

export default connect(R.applySpec({
  loading: selectors.loading,
  title: getTitle,
}))(OrganisationProfile);

